import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from 'store/User/Context';
import styled from 'styled-components';
import { Platform, usePlatform } from 'utils/hooks/usePlatform';

import Button from 'components/atom/Button';
import { IconEnum } from 'components/common/Icon';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    padding: 20px;
    text-align: center;
`;

const Title = styled.h1`
    color: var(--color-primary);
    margin-bottom: 20px;
    font-size: 24px;
`;

const Description = styled.p`
    color: var(--color-text);
    margin-bottom: 30px;
    max-width: 600px;
    line-height: 1.6;
    font-size: 16px;
`;

const ButtonContainer = styled.div`
    display: flex;
    gap: 15px;
    align-items: center;
`;

interface ModuleUnavailablePageProps {
    moduleName: string;
}

const ModuleUnavailablePage: FC<ModuleUnavailablePageProps> = ({ moduleName }) => {
    const navigate = useNavigate();
    const { user } = useUser();
    const isWordPressUser = user.isWordpressUser;
    const platform = usePlatform();

    const handlePurchase = () => {
        if (isWordPressUser) {
            window.location.href = 'https://investoro.pl/cennik/';
        } else if (platform === Platform.IOS) {
            navigate('/create-account-purchase-app-ios');
        } else {
            navigate('/create-account-purchase-app');
        }
    };

    return (
        <Container>
            <Title>Moduł <strong>{moduleName}</strong> niedostępny</Title>
            <Description>
                Aby korzystać z pełnej funkcjonalności aplikacji Skaner Okazji,
                musisz posiadać aktywną subskrypcję. Wykup odpowiedni pakiet,
                aby uzyskać dostęp do wszystkich funkcji platformy.
            </Description>
            {!(platform === Platform.IOS && isWordPressUser) &&
                <ButtonContainer>
                    <Button actionIcon={IconEnum.SEND} onClick={handlePurchase}>
                        Wykup subskrypcję
                    </Button>
                </ButtonContainer>
            }
            {platform === Platform.IOS && isWordPressUser &&
                <Description>
                    Subskrypcję możesz wykupić na stronie investoro.pl/cennik z poziomu przeglądarki na komputerze lub telefonie.
                </Description>
            }
        </Container>
    );
};

export default ModuleUnavailablePage;
